import "./index.scss";

import { Stack } from "@mui/material";
import Button from "components/Button";
import SearchBar from "components/SearchBar";
import Tabs from "components/Tabs";
import WorkoutPlanEditModal from "containers/MemberDetails/WorkoutPlanEditModal";
import React, { useCallback, useEffect, useState } from "react";
import { Location, useLocation, useNavigate } from "react-router-dom";

import CircuitCreateEditModal from "./CircuitCreateEditModal";
import CircuitsTab from "./CircuitsTab";
import { tabOptions } from "./data";
import ProtocolCreateEditModal from "./ProtocolCreateEditModal";
import ProtocolsTab from "./ProtocolsTab";
import WorkoutPlansTab from "./WorkoutPlansTab";

function WorkoutTemplates() {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
  const [searchValue, setSearchValue] = useState<string>("");
  const [showCreateProtocolModal, setShowCreateProtocolModal] = useState(false);
  const [showCreateCircuitModal, setShowCreateCircuitModal] = useState(false);
  const [showCreateWorkoutPlanModal, setShowCreateWorkoutPlanModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const updateTabIndex = useCallback((newLocation: Location) => {
    let pageIndex = tabOptions.findIndex((x) => newLocation.pathname.includes(x.value));
    if (pageIndex < 0) {
      setActiveTabIndex(0);
    } else {
      setActiveTabIndex(pageIndex);
    }
  }, []);

  useEffect(() => {
    updateTabIndex(location);
  }, [updateTabIndex, location]);

  //#region event handlers
  const handleChangeTab = useCallback(
    (tab: string) => {
      setSearchValue("");
      navigate(tab);
      setActiveTabIndex(tabOptions.findIndex((d) => d.value === tab));
    },
    [navigate]
  );

  const showCurrentContextCreateModal = () => {
    activeTabIndex === 0 && setShowCreateCircuitModal(true);
    activeTabIndex === 1 && setShowCreateProtocolModal(true);
    activeTabIndex === 2 && setShowCreateWorkoutPlanModal(true);
  };

  const handleCloseCreationModal = (isRefreshNeeded = false) => {
    setShowCreateCircuitModal(false);
    setShowCreateProtocolModal(false);
    setShowCreateWorkoutPlanModal(false);
    if (typeof isRefreshNeeded == "boolean" && isRefreshNeeded) {
      window.location.reload();
    }
  };
  //#endregion event handlers

  return (
    <>
      <div className={"workout-templates-container"}>
        <Tabs
          value={tabOptions[activeTabIndex].value}
          onChange={handleChangeTab}
          tabs={tabOptions}
          rightComp={
            <Stack direction="row" gap={2}>
              <SearchBar
                className="search-width-320"
                placeholder={`Search`}
                value={searchValue}
                onSearch={setSearchValue}
                isAsync={true}
              />
              <Button
                label={"Create"}
                color={"primary-green"}
                onClick={showCurrentContextCreateModal}
              />
            </Stack>
          }
        />
        {activeTabIndex === 0 && <CircuitsTab searchValue={searchValue} />}
        {activeTabIndex === 1 && <ProtocolsTab searchValue={searchValue} />}
        {activeTabIndex === 2 && <WorkoutPlansTab searchValue={searchValue} />}
      </div>
      <CircuitCreateEditModal open={showCreateCircuitModal} onClose={handleCloseCreationModal} />
      <ProtocolCreateEditModal open={showCreateProtocolModal} onClose={handleCloseCreationModal} />
      <WorkoutPlanEditModal open={showCreateWorkoutPlanModal} onClose={handleCloseCreationModal} />
    </>
  );
}

export default WorkoutTemplates;
